import React from 'react';
import { CircleAlert } from 'lucide-react';
import type { Engagement } from '../types';
import { formatDate } from '../utils/format';

interface UploadConflictModalProps {
  engagement: Engagement;
  onOverwrite: () => void;
  onDuplicate: () => void;
  onCancel: () => void;
}

export const UploadConflictModal: React.FC<UploadConflictModalProps> = ({
  engagement,
  onOverwrite,
  onDuplicate,
  onCancel,
}) => {
  return (
    <div className="fixed inset-0 bg-black/50 dark:bg-black/70 flex items-center justify-center z-50 p-4 transition-colors duration-300">
      <div className="bg-white dark:bg-neutral-900 rounded-lg shadow-2xl max-w-md w-full transition-colors duration-300">
        <div className="p-6">
          <h2 className="text-xl font-semibold mb-4 flex items-center gap-2 text-taxtrail-text dark:text-taxtrail-dark-text">
            <CircleAlert className="w-6 h-6 text-amber-600 dark:text-amber-500" />
            Engagement Already Exists
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-4">
            An engagement with this ID already exists in your library:
          </p>
          <div className="bg-gray-50 dark:bg-neutral-800 p-3 rounded mb-4 transition-colors duration-300">
            <p className="font-medium text-taxtrail-text dark:text-taxtrail-dark-text">{engagement.clientName}</p>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              {formatDate(engagement.taxYearEnd)} • {engagement.taxForm}
            </p>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Would you like to overwrite the existing engagement or create a
            duplicate?
          </p>
        </div>

        <div className="p-6 border-t border-gray-200 dark:border-neutral-700 flex gap-3 justify-end">
          <button
            onClick={onCancel}
            className="px-4 py-2 border border-gray-300 dark:border-neutral-600 rounded hover:bg-gray-50 dark:hover:bg-neutral-800 transition-colors font-medium text-taxtrail-text dark:text-taxtrail-dark-text focus:outline-none focus:ring-2 focus:ring-green-600 dark:focus:ring-green-500"
          >
            Cancel
          </button>
          <button
            onClick={onDuplicate}
            className="px-4 py-2 bg-blue-600 dark:bg-blue-700 text-white rounded hover:bg-blue-700 dark:hover:bg-blue-800 transition-colors font-medium focus:outline-none focus:ring-2 focus:ring-blue-600 dark:focus:ring-blue-500"
          >
            Create Duplicate
          </button>
          <button
            onClick={onOverwrite}
            className="px-4 py-2 bg-amber-600 dark:bg-amber-700 text-white rounded hover:bg-amber-700 dark:hover:bg-amber-800 transition-colors font-medium focus:outline-none focus:ring-2 focus:ring-amber-600 dark:focus:ring-amber-500"
          >
            Overwrite
          </button>
        </div>
      </div>
    </div>
  );
};

